import {
  Dispatch,
  ReactElement,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';

import { SearchPopup } from 'components/SearchPopup/SearchPopup';
import {
  openSearch,
  searchSelector,
  closeSearch,
  resetHasBeenOpened,
} from 'redux/search/search.slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

interface IUseSearchPopupReturn {
  searchPopup: ReactElement | null;
  open: (initialValue?: string) => void;
  close: () => void;
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
}

export const useSearchPopup = (): IUseSearchPopupReturn => {
  const [searchValue, setSearchValue] = useState('');

  const { isOpen: isModalOpen, hasBeenOpened } = useAppSelector(searchSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setSearchValue('');
  }, [isModalOpen]);

  const close = useCallback(() => {
    dispatch(closeSearch());
    setTimeout(() => dispatch(resetHasBeenOpened()), 350);
  }, [dispatch]);

  const open = useCallback(() => {
    dispatch(
      openSearch({
        isOpen: true,
        hasBeenOpened: true,
        initialSearch: searchValue,
      })
    );
  }, [dispatch, searchValue]);

  return {
    // unmounted once the close animation is done, so the search holds no
    // query subscriptions while the popup is hidden
    searchPopup:
      isModalOpen || hasBeenOpened ? (
        <SearchPopup
          onClose={close}
          displayCloseAnimation={!isModalOpen && hasBeenOpened}
          displayOpenAnimation={isModalOpen}
        />
      ) : null,
    open,
    close,
    searchValue,
    setSearchValue,
  };
};
